
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ens-v2",
      function () {
        return require("private-next-pages/ens-v2.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ens-v2"])
      });
    }
  